import { getFulfillmentType } from '../../../../Product.utils'
import type { ProductFormState } from '../../../SingleProduct.types'
import type { ShippingView } from '../types'

export type ShippingViewModel = {
  view: ShippingView
}

export const getShippingViewModel = ({
  values,
  featureEnabled,
}: {
  values: ProductFormState
  featureEnabled: boolean
}): ShippingViewModel => {
  const fulfillmentType = getFulfillmentType(values.fulfillmentService)
  const manufacturingService = values.manufacturingService

  let view: ShippingView = 'NOT_CONFIGURABLE'

  if (fulfillmentType === 'DIGITAL') {
    view = 'NO_SHIPPING'
  }

  if (
    (fulfillmentType === 'SHIP_MONK' || fulfillmentType === 'CART_JAZZ') &&
    manufacturingService === 'MANUFACTURED_BY_CREATOR'
  ) {
    view = featureEnabled ? 'SHIPPING_3PL' : 'SHIPPING_3PL_LEGACY'
  }

  if (
    fulfillmentType === 'FULFILLED_BY_CREATOR' &&
    manufacturingService === 'MANUFACTURED_BY_CREATOR'
  ) {
    // NOTE: for now, we only support weight-based self shipping we will support FLAT_SELF_SHIPPING in the future
    view = 'WEIGHT_BASED_SELF_SHIPPING'
  }

  if (manufacturingService === 'FOURTHWALL_BESPOKE') {
    view = 'BESPOKE_SHIPPING'
  }

  return { view }
}
